import { motion } from 'framer-motion'
import {ImHtmlFive } from 'react-icons/im'
import { SiCss3 } from 'react-icons/si'
import { SiJavascript } from 'react-icons/si'
import { GrReactjs } from 'react-icons/gr'
import { BsFillBootstrapFill } from 'react-icons/bs'
import { SiNextdotjs } from 'react-icons/si'


function Stack() {
    return (
        <div className='stack-container'>
            <h1 className="stack">I Am Fluent In:</h1>
            <motion.div 
             initial={{ y: 1000 }}
             animate={{ y: 0 }}
             transition={{
               ease:'easeOut',
                 type: "tween",
                 duration: "3",
                 delay: "2"
             }}
            
            
            
            className="container">
              
                    <div> <ImHtmlFive fill = '#f06529' />HTML5</div>
                    <div> <SiCss3 fill = '#2965f1' />CSS3</div>
                <div> <SiJavascript fill = '#f0db4f' />JAVASCRIPT</div>
                <div> <GrReactjs fill = '#61dbfb' />REACT JS</div>
                <div> <BsFillBootstrapFill fill = '#563d7c' />BOOTSTRAP</div>
               
                {/* <div> <SiNextdotjs fill = 'blue' /><span>NEXT.JS</span></div>
                 */}
               
               
            </motion.div>
        </div>
    )
}

export default Stack;